module.exports = __webpack_public_path__ + "static/img/animation.99bd9cfb.png";